import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import { db } from '../../lib/supabase'

export default function Descuentos() {
  const [descuentos, setDescuentos] = useState([])
  const [tiendas, setTiendas] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [selectedDescuento, setSelectedDescuento] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedEstado, setSelectedEstado] = useState('')

  useEffect(() => {
    fetchDescuentos()
    fetchTiendas()
  }, [])

  const fetchDescuentos = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('descuentos')
        .select(`
          *,
          descuentos_marcas(id, tienda_id, brand_name)
        `)
        .order('fecha_inicio', { ascending: false })

      if (error) throw error
      setDescuentos(data || [])
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchTiendas = async () => {
    const { data } = await db.getTiendas()
    setTiendas(data || [])
  }

  const handleDelete = async (id) => {
    if (!confirm('¿Estás seguro de eliminar este descuento?')) return
    
    const { error } = await supabase
      .from('descuentos')
      .delete()
      .eq('id', id)
    
    if (!error) {
      fetchDescuentos()
      alert('Descuento eliminado exitosamente')
    }
  }

  const togglePublicado = async (id, currentState) => {
    const { error } = await supabase
      .from('descuentos')
      .update({ publicado: !currentState })
      .eq('id', id)

    if (!error) {
      fetchDescuentos()
    }
  }

  const toggleActivo = async (id, currentState) => {
    const { error } = await supabase
      .from('descuentos')
      .update({ activo: !currentState })
      .eq('id', id)

    if (!error) {
      fetchDescuentos()
    }
  }

  const filteredDescuentos = descuentos.filter(descuento => {
    const matchesSearch = descuento.titulo.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesEstado = !selectedEstado || (selectedEstado === 'publicado' ? descuento.publicado : !descuento.publicado)
    return matchesSearch && matchesEstado
  })

  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1.5rem'
      }}>
        <h1 style={{
          fontSize: 'var(--h1)',
          fontWeight: '700',
          fontFamily: "'Poppins', sans-serif",
          color: 'var(--textPrimary)'
        }}>Gestión de Descuentos</h1>
        <button
          onClick={() => {
            setSelectedDescuento(null)
            setShowModal(true)
          }}
          style={{
            padding: '0.75rem 1.5rem',
            background: 'var(--ctaBg)',
            color: 'var(--ctaText)',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            fontSize: 'var(--body)',
            fontWeight: '600',
            fontFamily: "'Inter', sans-serif",
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'var(--accentPurpleDark)'
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(184, 146, 209, 0.3)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'var(--ctaBg)'
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = 'none'
          }}
        >
          + Nuevo Descuento
        </button>
      </div>

      {/* Filtros */}
      <div style={{
        background: 'var(--surface)',
        padding: '1.5rem',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-card)',
        border: 'var(--card-border)',
        marginBottom: '1.5rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem'
        }}>
          <input
            type="text"
            placeholder="Buscar descuento..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: "'Inter', sans-serif",
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(184, 146, 209, 0.1)'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          />
          <select
            value={selectedEstado}
            onChange={(e) => setSelectedEstado(e.target.value)}
            style={{
              padding: '0.75rem 1rem',
              border: '1px solid var(--mutedStroke)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--body)',
              fontFamily: "'Inter', sans-serif",
              color: 'var(--textPrimary)',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
              cursor: 'pointer'
            }}
            onFocus={(e) => {
              e.currentTarget.style.outline = 'none'
              e.currentTarget.style.borderColor = 'var(--accentPurple)'
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(184, 146, 209, 0.1)'
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--mutedStroke)'
              e.currentTarget.style.boxShadow = 'none'
            }}
          >
            <option value="">Todos los estados</option>
            <option value="publicado">Publicados</option>
            <option value="borrador">Borradores</option>
          </select>
        </div>
      </div>

      {/* Tabla de Descuentos */}
      <div style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-card)',
        border: 'var(--card-border)',
        overflow: 'hidden'
      }}>
        {loading ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              border: '3px solid var(--background)',
              borderTop: '3px solid var(--accentPurple)',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 1rem'
            }}></div>
            <p style={{
              fontSize: 'var(--body)',
              fontFamily: "'Inter', sans-serif",
              color: 'var(--textMuted)'
            }}>Cargando...</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse'
            }}>
              <thead style={{
                background: 'var(--background)'
              }}>
                <tr>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: "'Inter', sans-serif",
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Estado</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: "'Inter', sans-serif",
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Título</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: "'Inter', sans-serif",
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Vigencia</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: "'Inter', sans-serif",
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Marcas</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: "'Inter', sans-serif",
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Activo</th>
                  <th style={{
                    padding: '1rem 1.5rem',
                    textAlign: 'left',
                    fontSize: 'var(--small)',
                    fontWeight: '500',
                    fontFamily: "'Inter', sans-serif",
                    color: 'var(--textMuted)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>Acciones</th>
                </tr>
              </thead>
              <tbody style={{
                background: 'var(--surface)'
              }}>
                {filteredDescuentos.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{
                      padding: '3rem 1.5rem',
                      textAlign: 'center',
                      fontSize: 'var(--body)',
                      fontFamily: "'Inter', sans-serif",
                      color: 'var(--textMuted)'
                    }}>
                      No se encontraron descuentos
                    </td>
                  </tr>
                ) : (
                  filteredDescuentos.map((descuento) => (
                    <tr key={descuento.id} style={{
                      borderTop: '1px solid var(--mutedStroke)',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'var(--background)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        <button
                          onClick={() => togglePublicado(descuento.id, descuento.publicado)}
                          style={{
                            padding: '0.5rem 0.75rem',
                            borderRadius: 'var(--radius-pill)',
                            fontSize: 'var(--small)',
                            fontWeight: '600',
                            fontFamily: "'Inter', sans-serif",
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            background: descuento.publicado ? '#D1FAE5' : '#F3F4F6',
                            color: descuento.publicado ? '#065F46' : '#374151'
                          }}
                        >
                          {descuento.publicado ? '✓ Publicado' : '📝 Borrador'}
                        </button>
                      </td>
                      <td style={{
                        padding: '1rem 1.5rem',
                        fontWeight: '500',
                        fontFamily: "'Inter', sans-serif",
                        color: 'var(--textPrimary)'
                      }}>{descuento.titulo}</td>
                      <td style={{
                        padding: '1rem 1.5rem',
                        fontSize: 'var(--small)',
                        fontFamily: "'Inter', sans-serif",
                        color: 'var(--textPrimary)'
                      }}>
                        {descuento.fecha_inicio} {descuento.fecha_fin && `— ${descuento.fecha_fin}`}
                      </td>
                      <td style={{
                        padding: '1rem 1.5rem',
                        fontSize: 'var(--small)',
                        fontFamily: "'Inter', sans-serif",
                        color: 'var(--textPrimary)'
                      }}>
                        {descuento.descuentos_marcas?.length || 0} marca(s)
                      </td>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        <button
                          onClick={() => toggleActivo(descuento.id, descuento.activo)}
                          style={{
                            padding: '0.5rem 0.75rem',
                            borderRadius: 'var(--radius-pill)',
                            fontSize: 'var(--small)',
                            fontWeight: '600',
                            fontFamily: "'Inter', sans-serif",
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            background: descuento.activo ? '#DBEAFE' : '#FEE2E2',
                            color: descuento.activo ? '#1E40AF' : '#991B1B'
                          }}
                        >
                          {descuento.activo ? '✓ Activo' : '❌ Inactivo'}
                        </button>
                      </td>
                      <td style={{ padding: '1rem 1.5rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button
                            onClick={() => {
                              setSelectedDescuento(descuento)
                              setShowModal(true)
                            }}
                            style={{
                              background: 'none',
                              border: 'none',
                              fontSize: 'var(--small)',
                              fontFamily: "'Inter', sans-serif",
                              color: 'var(--accentPurple)',
                              cursor: 'pointer',
                              padding: '0.25rem 0.5rem',
                              transition: 'opacity 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => handleDelete(descuento.id)}
                            style={{
                              background: 'none',
                              border: 'none',
                              fontSize: 'var(--small)',
                              fontFamily: "'Inter', sans-serif",
                              color: '#DC2626',
                              cursor: 'pointer',
                              padding: '0.25rem 0.5rem',
                              transition: 'opacity 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                          >
                            Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal CRUD */}
      {showModal && (
        <DescuentoFormModal
          descuento={selectedDescuento}
          tiendas={tiendas}
          onClose={() => {
            setShowModal(false)
            setSelectedDescuento(null)
          }}
          onSuccess={() => {
            setShowModal(false)
            setSelectedDescuento(null)
            fetchDescuentos()
          }}
        />
      )}
    </div>
  )
}

// Modal para crear/editar descuento
function DescuentoFormModal({ descuento, tiendas, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    titulo: descuento?.titulo || '',
    descripcion: descuento?.descripcion || '',
    imagen_url: descuento?.imagen_url || '',
    imagen_alt: descuento?.imagen_alt || '',
    fecha_inicio: descuento?.fecha_inicio || '',
    fecha_fin: descuento?.fecha_fin || '',
    publicado: descuento?.publicado !== undefined ? descuento.publicado : true,
    activo: descuento?.activo !== undefined ? descuento.activo : true,
    meta_title: descuento?.meta_title || '',
    meta_description: descuento?.meta_description || '',
    canonical_url: descuento?.canonical_url || '',
    og_image_url: descuento?.og_image_url || '',
    json_ld: descuento?.json_ld || '',
    robots_index: descuento?.robots_index !== undefined ? descuento.robots_index : true,
  })
  const [marcas, setMarcas] = useState([])
  const [newMarca, setNewMarca] = useState({
    tienda_id: '',
    brand_name: '',
    brand_logo_url: '',
    brand_url: '',
    created_as_store: false
  })
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (descuento?.id) {
      loadMarcas()
    }
  }, [descuento])

  const loadMarcas = async () => {
    const { data } = await supabase
      .from('descuentos_marcas')
      .select('*')
      .eq('descuento_id', descuento.id)
    setMarcas(data || [])
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)

    try {
      if (descuento?.id) {
        // Update existing
        const { error } = await db.updateDescuentoMaster(descuento.id, formData)
        if (error) throw error
      } else {
        // Create new
        const { data: newDesc, error } = await db.createDescuentoMaster(formData)
        if (error) throw error
        
        // Optionally add marcas here if needed
      }

      alert(descuento?.id ? 'Descuento actualizado' : 'Descuento creado')
      onSuccess()
    } catch (error) {
      console.error('Error:', error)
      alert('Error al guardar el descuento')
    } finally {
      setSubmitting(false)
    }
  }

  const addMarca = async () => {
    if (!descuento?.id) {
      alert('Primero guarda el descuento')
      return
    }

    try {
      await db.upsertDescuentoMarca({
        descuento_id: descuento.id,
        tienda_id: newMarca.tienda_id || null,
        brand_name: newMarca.tienda_id ? null : newMarca.brand_name || null,
        brand_logo_url: newMarca.tienda_id ? null : newMarca.brand_logo_url || null,
        brand_url: newMarca.tienda_id ? null : newMarca.brand_url || null,
        created_as_store: newMarca.created_as_store
      })
      loadMarcas()
      setNewMarca({ tienda_id: '', brand_name: '', brand_logo_url: '', brand_url: '', created_as_store: false })
    } catch (error) {
      console.error('Error:', error)
      alert('Error al agregar marca')
    }
  }

  const removeMarca = async (id) => {
    await db.deleteDescuentoMarca(id)
    loadMarcas()
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        width: '90%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflowY: 'auto',
        padding: '2rem'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem'
        }}>
          <h2 style={{
            fontSize: 'var(--h2)',
            fontWeight: '700',
            fontFamily: "'Poppins', sans-serif",
            color: 'var(--textPrimary)',
            margin: 0
          }}>{descuento ? 'Editar Descuento' : 'Nuevo Descuento'}</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: 'var(--textMuted)'
            }}
          >×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gap: '1rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Título *</label>
              <input
                required
                value={formData.titulo}
                onChange={(e) => setFormData({ ...formData, titulo: e.target.value })}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid var(--mutedStroke)',
                  borderRadius: 'var(--radius-md)'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Descripción</label>
              <textarea
                value={formData.descripcion}
                onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                rows={4}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid var(--mutedStroke)',
                  borderRadius: 'var(--radius-md)'
                }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Imagen URL</label>
                <input
                  value={formData.imagen_url}
                  onChange={(e) => setFormData({ ...formData, imagen_url: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid var(--mutedStroke)',
                    borderRadius: 'var(--radius-md)'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Alt Text</label>
                <input
                  value={formData.imagen_alt}
                  onChange={(e) => setFormData({ ...formData, imagen_alt: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid var(--mutedStroke)',
                    borderRadius: 'var(--radius-md)'
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Fecha Inicio *</label>
                <input
                  required
                  type="date"
                  value={formData.fecha_inicio}
                  onChange={(e) => setFormData({ ...formData, fecha_inicio: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid var(--mutedStroke)',
                    borderRadius: 'var(--radius-md)'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Fecha Fin</label>
                <input
                  type="date"
                  value={formData.fecha_fin}
                  onChange={(e) => setFormData({ ...formData, fecha_fin: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid var(--mutedStroke)',
                    borderRadius: 'var(--radius-md)'
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '1.5rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="checkbox"
                  checked={formData.publicado}
                  onChange={(e) => setFormData({ ...formData, publicado: e.target.checked })}
                />
                Publicado
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="checkbox"
                  checked={formData.activo}
                  onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                />
                Activo
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="checkbox"
                  checked={formData.robots_index}
                  onChange={(e) => setFormData({ ...formData, robots_index: e.target.checked })}
                />
                Indexable (SEO)
              </label>
            </div>

            <details style={{ marginTop: '1rem' }}>
              <summary style={{ cursor: 'pointer', fontWeight: '600', marginBottom: '1rem' }}>SEO Avanzado (Opcional)</summary>
              <div style={{ display: 'grid', gap: '1rem', paddingLeft: '1rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Meta Title</label>
                  <input
                    value={formData.meta_title}
                    onChange={(e) => setFormData({ ...formData, meta_title: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid var(--mutedStroke)',
                      borderRadius: 'var(--radius-md)'
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Meta Description</label>
                  <textarea
                    value={formData.meta_description}
                    onChange={(e) => setFormData({ ...formData, meta_description: e.target.value })}
                    rows={2}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid var(--mutedStroke)',
                      borderRadius: 'var(--radius-md)'
                    }}
                  />
                </div>
              </div>
            </details>

            {descuento?.id && (
              <details style={{ marginTop: '1rem' }}>
                <summary style={{ cursor: 'pointer', fontWeight: '600', marginBottom: '1rem' }}>Marcas Participantes ({marcas.length})</summary>
                <div style={{ paddingLeft: '1rem' }}>
                  <div style={{ marginBottom: '1rem' }}>
                    <select
                      value={newMarca.tienda_id}
                      onChange={(e) => setNewMarca({ ...newMarca, tienda_id: e.target.value })}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid var(--mutedStroke)',
                        borderRadius: 'var(--radius-md)',
                        marginBottom: '0.5rem'
                      }}
                    >
                      <option value="">Seleccionar tienda existente...</option>
                      {tiendas.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                    </select>
                    <button
                      type="button"
                      onClick={addMarca}
                      disabled={!newMarca.tienda_id}
                      style={{
                        padding: '0.5rem 1rem',
                        background: 'var(--ctaBg)',
                        color: 'white',
                        border: 'none',
                        borderRadius: 'var(--radius-md)',
                        cursor: 'pointer'
                      }}
                    >
                      + Agregar tienda
                    </button>
                  </div>

                  {marcas.length > 0 && (
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                      {marcas.map(m => (
                        <li key={m.id} style={{
                          padding: '0.5rem',
                          border: '1px solid var(--mutedStroke)',
                          borderRadius: 'var(--radius-md)',
                          marginBottom: '0.5rem',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}>
                          <span>{m.brand_name || 'Tienda vinculada'}</span>
                          <button
                            type="button"
                            onClick={() => removeMarca(m.id)}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#DC2626',
                              cursor: 'pointer'
                            }}
                          >×</button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </details>
            )}
          </div>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-end',
            marginTop: '2rem',
            paddingTop: '1rem',
            borderTop: '1px solid var(--mutedStroke)'
          }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '0.75rem 1.5rem',
                background: 'var(--background)',
                border: '1px solid var(--mutedStroke)',
                borderRadius: 'var(--radius-md)',
                cursor: 'pointer'
              }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={submitting}
              style={{
                padding: '0.75rem 1.5rem',
                background: 'var(--ctaBg)',
                color: 'var(--ctaText)',
                border: 'none',
                borderRadius: 'var(--radius-md)',
                cursor: submitting ? 'not-allowed' : 'pointer',
                opacity: submitting ? 0.6 : 1
              }}
            >
              {submitting ? 'Guardando...' : (descuento ? 'Actualizar' : 'Crear Descuento')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
